import { ValueType } from '@hg-akademie-ban/vamos-viva-type-utils';
import { z } from 'zod';

export const calendarCollapsibleRows = {
  SEMINARRAUM: 'seminarraum', // Haupt-Raum der Veranstaltung: Standardraum (in Hotel) | Raum in PC-Center | Raum in Veranstaltungslocation
  GRUPPENRAUM: 'gruppenraum',
  STANDORT: 'standort',
  EXPERTE: 'experte',
  HAUPTTRAINER: 'haupttrainer',
  NEBENTRAINER: 'nebentrainer',
  ERSATZTRAINER: 'ersatztrainer',
} as const;

export type CalendarCollapsibleRow = ValueType<typeof calendarCollapsibleRows>;
export const calendarCollapsibleRowSchema = z.enum(calendarCollapsibleRows);
